import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmationModalDialogComponent } from 'app/modules/well-production-status/component/confirmation-modal-dialog/confirmation-modal-dialog.component';
import { OptionTypeService } from 'app/modules/option-type/services/option-type.service';
import { WellProductionService } from 'app/modules/well-production-status/services/well-production-status.service';
import { handleFormatDate } from 'app/core/shared/helper/date.helper';
import module from "app/modules/well-production-status/well-production-status.module";

@Component({
  selector: 'app-edit-well-prod-modal',
  templateUrl: './edit-well-prod-modal.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: module,
  styleUrls: ['./edit-well-prod-modal.component.scss']
})
export class EditWellProdModalComponent {
  public wellProdDetailsBody = {
    fieldName: '',
    lastUpdatedBy: '',
    lastUpdatedDate: '',
    platformName: '',
    prodStatus: '',
    wellStringName: '',
    wellStringId: '',
    wellStringIndicator: '',
    stringIndicatorShortName: '',
    wellType: '',
    flowCategory: '',
  }

  public tempWellProdDetails : any = {}
  public isSuccess: boolean = false
  public isLoading: boolean = false
  public tempProdStatus = ''

  public productionStatusList: any = []
  public wellTypeList : any = []
  public flowCategoryList : any = []

  constructor(
    public dialogRef: MatDialogRef<EditWellProdModalComponent>,
    @Inject(MAT_DIALOG_DATA) public wellProductionDetails: any,
    public dialog: MatDialog,
    private optionTypeServices: OptionTypeService,
    private wellProdServices: WellProductionService,
  ) { }

  ngOnInit(): void {
    this.getWellTypeList()
    this.getProductionStatusList()
    this.getFlowCategoryList()

    this.wellProdDetailsBody = {
      fieldName: this.wellProductionDetails.fieldLongName,
      lastUpdatedBy: this.wellProductionDetails.lastUpdatedBy,
      lastUpdatedDate: this.handleFormatDate(this.wellProductionDetails.lastUpdatedDate),
      platformName: this.wellProductionDetails.platformLongName,
      prodStatus: this.wellProductionDetails.prodStatus,
      wellStringName: this.wellProductionDetails.stringShortName,
      wellStringId: this.wellProductionDetails.wellStringId,
      wellStringIndicator: this.wellProductionDetails.stringIndicator,
      stringIndicatorShortName: this.wellProductionDetails.stringIndicatorShortName,
      wellType: this.wellProductionDetails.wellStringType,
      flowCategory: this.wellProductionDetails.wellFlowCategory,
    }

    this.tempWellProdDetails = { ...this.wellProdDetailsBody }
    this.tempProdStatus = this.wellProductionDetails.prodStatus
  }

  private getProductionStatusList(){
    this.optionTypeServices.getOptionItems('md_prod_status').subscribe((res) => {
      let prodStatus = res.data
      this.productionStatusList = prodStatus.map(item => item.name)
    })
  }

  private getWellTypeList(){
    this.optionTypeServices.getOptionItems('md_well_type').subscribe((res) => {
      let optionItems = res.data
      this.wellTypeList = optionItems.map(item => item.name)
    })
  }

  private getFlowCategoryList(){
    this.optionTypeServices.getOptionItems('md_well_flow_category').subscribe((res) => {
      let flowCat = res.data
      this.flowCategoryList = flowCat.map(item => item.name)
    })
  }

  isProductionStatusDetailsChange(): boolean {
    return JSON.stringify(this.wellProdDetailsBody) === JSON.stringify(this.tempWellProdDetails) || this.isLoading;
  }

  isStatusChange(): boolean {
    // Compare the production status properties
    const statusChanged = this.wellProdDetailsBody.prodStatus !== this.tempWellProdDetails.prodStatus;
  
    // Return true if the status has changed or if loading is in progress
    return statusChanged;
  }

  updateWellProdStatus() {
    let wellProdBody = {
      wellStringId: this.wellProdDetailsBody.wellStringId,
      status: this.wellProdDetailsBody.prodStatus,
      wellType: this.wellProdDetailsBody.wellType,
      flowCategory: !this.wellProdDetailsBody.wellType.includes('Oil') ? null :  this.wellProdDetailsBody.flowCategory
    }

    if(this.isStatusChange()){
      this.confirmUpdateModal()
    } else {
      this.wellProdServices.updateWellProdStatus(wellProdBody).subscribe((res) => {
        if (res.isSuccess) {
          this.isSuccess = true
          this.closeDialog()
        }
      })
    }
  }

  confirmUpdateModal() {
    const dialogRef = this.dialog.open(ConfirmationModalDialogComponent, {
      data: this.wellProdDetailsBody,
      width: "40%"
    });

    dialogRef.afterClosed().subscribe(isSuccess => {
      this.isSuccess = isSuccess
      if(this.isSuccess) this.closeDialog()
    });
  }

  closeDialog(): void {
    this.dialogRef.close(this.isSuccess);
  }

  handleFormatDate(date: string){
    return handleFormatDate(date, false)
  }
}
